module.exports = __webpack_public_path__ + "img/517b13c27c0a49be8a535e8fe58e8320.b2202761.png";